import { ReactNode, useEffect } from 'react';
import UXAlert from '@ux/alert';
import '@ux/alert/styles';
import clsx from 'clsx';

import { studioTacAlert } from './Alert.css';

type Props = {
  actions?: ReactNode;
  ariaLabels?: {
    close: string;
  };
  contrast?: boolean;
  className?: string;
  children?: ReactNode;
  emphasis?: 'critical' | 'warning' | 'highlight' | 'success' | 'info' | 'neutral' | 'internal' | 'studio-tac';
  icon?: ReactNode;
  id?: string;
  onClose?: () => void;
  space?: object;
  stretch?: boolean;
  title?: ReactNode;
  callBack?: () => void;
  description?: ReactNode;
};

const Alert = ({ description, callBack, children, className, emphasis, ...restProps }: Props) => {
  useEffect(() => {
    if (callBack && typeof callBack === 'function') {
      callBack();
    }
  }, [callBack]);

  const content = description ?? children;

  return (
    <UXAlert
      {...restProps}
      emphasis={emphasis === 'studio-tac' ? undefined : emphasis}
      className={clsx(className, { [studioTacAlert]: emphasis === 'studio-tac' })}
    >
      {content}
    </UXAlert>
  );
};

export default Alert;
